module.exports = __webpack_public_path__ + "static/media/34-3.71c0163d.mp3";